export default __webpack_public_path__ + "static/media/logo.a1782f0a.png";